import type ThemeStore from '../schema/ThemeStore';
import { BASE_DARK_THEME_ID, BASE_THEME_ID } from '../constants/constants';
import { BASE_DARK_THEME_PALETTE } from '../constants/baseDarkThemePalette';
import { BASE_LIGHT_THEME_PALETTE } from '../constants/baseLightThemePalette';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import { ThemeMode } from '../schema/ThemeMode';
import type { ThemeResources } from '../schema/ThemeResources';

const INIT_STORE: ThemeStore = {
    currentThemeId: BASE_THEME_ID,
    themeMode: ThemeMode.Light,
    isDarkTheme: false,
    customPalette: {},
    themeData: new ObservableMap<string, ThemeResources>({
        [BASE_THEME_ID]: { themePalette: BASE_LIGHT_THEME_PALETTE },
        [BASE_DARK_THEME_ID]: { themePalette: BASE_DARK_THEME_PALETTE },
    }),
};

export const store = createStore<ThemeStore>('miniThemeStore', INIT_STORE)();
